import React from 'react';
import googleDrive from '../../images/integrations/Google_Drive_.svg';

import IntegrationBot from '../../components/integrationn/index';

const GoogleDrive = () => <IntegrationBot botLogo={googleDrive} botName={'Google Drive'} />;

export default GoogleDrive;
